import { Pipe, PipeTransform } from '@angular/core';
import { PromptRegisterViewComponent } from 'src/app/pages/prompt-register/views/prompt-register-view.component';

@Pipe({
    name: 'promptRegisterHover',
    standalone: false
})
export class PromptRegisterHoverPipe implements PipeTransform {
  constructor(private promptRegisterViewComponent: PromptRegisterViewComponent) {}
  transform(promptId: number, typeName: string): string {
    return this.promptRegisterViewComponent.buildMessage(promptId, typeName);
  }
}